import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MensajesProvider } from '../mensajes/mensajes';
import { NavController } from '@ionic/angular';
import { LocalDataService } from '../almacenamiento/local-data.service';

@Injectable({
  providedIn: 'root'
})
export class HttpApiProvider {

  constructor(
    public http: HttpClient,
    private mensajesService: MensajesProvider,
    private navCtrl: NavController,
    private localDataService: LocalDataService,
  ) {
  }

  public ejecutarGetQuery<T>(apiUrl: string, predicado: string): Observable<T> {
    const strApiRequest = `${apiUrl}${predicado}`;
    return this.http.get<T>(strApiRequest);
  }

  public ejecutarPostQuery<T>(apiUrl: string, predicado: string, body: any): Observable<T> {
    const strApiRequest = `${apiUrl}${predicado
      }`;
    return this.http.post<T>(strApiRequest, body);
  }

  public ejecutarPutQuery<T>(apiUrl: string, predicado: string, body: any): Observable<T> {
    const strApiRequest = `${apiUrl
      }${predicado
      }`;
    return this.http.put<T>(strApiRequest, body);
  }

  public ejecutarDeleteQuery<T>(apiUrl: string, predicado: string): Observable<T> {
    const strApiRequest = `${apiUrl
      }${predicado
      }`;
    return this.http.delete<T>(strApiRequest);
  }

  public ejecutarPostQueryEspecial<T>(apiUrl: string, predicado: string, body: any): Observable<T> {

    const httpHeaders = new HttpHeaders()
      .set('Accept', 'image/png')
      .set('Content-Type', 'application/x-www-form-urlencoded')
      .set('cache-control', 'no-cache')
      .set('accept-encoding', 'gzip, deflate')
      .set('Host', 'api.labelary.com')
      .set('Connection', 'keep-alive');
    const options = {
      headers: httpHeaders
    };
    const strApiRequest = `${apiUrl
      }${predicado
      }`;
    return this.http.post<T>(strApiRequest, body, options);
  }

  public async manejadorErroresApi(error: any): Promise<boolean> {
    return new Promise<boolean>(async resolve => {
      console.log({ error });

      let title = 'Algo ha salido mal. 😥';
      let message = 'Error desconocido ...';


      if (!!error && !!error.status && error.status >= 0) {

        switch (error.status) {
          case 0:
            if (error.message && error.message !== '') {

              message = `No se puede acceder al servicio,
            el servidor rechazó la conexión
            ERR_CONNECTION_REFUSED
            ${error.message}`;

              // await this.mensajesService.alertaInformativa(message);
            } else {
              message = `No se puede acceder al servicio,
            el servidor rechazó la conexión
            ERR_CONNECTION_REFUSED`;

              // await this.mensajesService.alertaInformativa(
              //   `No se puede acceder al servicio API,
              //    el servidor rechazó la conexión
              //    ERR_CONNECTION_REFUSED`);
            }
            break;
          case 401:
            if (error.error && error.error.Hint === 'Favor de validar password.') {
              // this.mensajesService.alertaInformativaPromise(error.error.Hint, error.error.Message);
              message = error.error.Message;
              title = `${error.error.Hint} 😥`;
            } else {

              if (!!error.error && !!error.error.Message && error.error.Message !== 'The underlying provider failed on Open.') {
                // this.storage.remove('passCard');
                this.localDataService.boorrarLlavesLogOut();

                message = error.error.Message;
                title = `${error.error.Hint} 😥`;
                this.goToLogIn();
              } else if (error.error.Message === 'The underlying provider failed on Open.') {
                message = error.error.Message;
                title = `${error.error.Hint} 😥`;
              }
              else {
                // borrar del storage
                // this.storage.remove('passCard');
                this.localDataService.boorrarLlavesLogOut();

                message = 'Por favor vuelva a introducir sus credenciales.';
                title = 'Su sesión ha caducado. 📴';
                // await this.mensajesService
                // .alertaInformativaPromise('Su sesión ha caducado', 'Por favor vuelva a introducir sus credenciales.');
                this.goToLogIn();
              }
            }
            break;
          case 500:
            if (error._body) {
              const errorAPI = JSON.parse(error._body);
              if (errorAPI && errorAPI.Message && errorAPI.Message !== '') {
                // this.mensajesService.alertaInformativaPromise(errorAPI.Hint, errorAPI.Message);
                message = errorAPI.Message;
                title = `${errorAPI.Hint} 😥`;
              }
            } else if (error.error) {
              if (error.error.Hint && error.error.Message) {
                // this.mensajesService.alertaInformativaPromise(error.error.Hint, error.error.Message);
                message = error.error.Message;
                title = `${error.error.Hint} 😥`;
              } else if (error.error.message && error.error.hint) {
                message = error.error.message;
                title = `${error.error.Hint} 😥`;
              } else {
                // this.mensajesService.alertaInformativaPromise(error.error.Message, error.error.ExceptionMessage);
                message = error.error.ExceptionMessage;
                title = `${error.error.Message} 😥`;
              }
            } else {
              // await this.mensajesService.alertaInformativa('Error desconocido 500');
              message = 'Error desconocido 500';
            }


            break;
          default:
            // await this.mensajesService.alertaInformativa('Error desconocido');
            message = 'Error desconocido';
            break;
        }



      } else if (error.xhr && error.xhr) {
        switch (error.xhr.status) {
          case 401:
            if (error.error !== 'The underlying provider failed on Open.') {
              // this.storage.remove('passCard');
              this.localDataService.boorrarLlavesLogOut();
              message = error.error;
              title = `${error.error} 😥`;
              // this.mensajesService.alertaInformativaPromise(error.error.Hint, error.error.Message);
              this.goToLogIn();
            } else {
              message = error.error;
              title = `${error.error} 😥`;
            }
            break;
          default:

            if (!!error && !!error._body) {
              const errorAjax = JSON.parse(error._body);
              if (errorAjax && errorAjax.Message && errorAjax.Message !== '') {
                // this.mensajesService.alertaInformativaPromise(errorAjax.Hint, errorAjax.Message);
                message = errorAjax.Message;
                title = `${errorAjax.Hint} 😥`;
              }
            }
            break;
        }
      } else {
        if (!!error.error && !!error.error.Message) {
          // this.mensajesService.alertaInformativaPromise(error.error.Hint, error.error.Message);
          message = error.error.Message;
          title = `${error.error.Hint} 😥`;

        } else if (error.message) {
          if (error.message.includes('unknown url')) {
            // this.mensajesService.alertaInformativaPromise('Valide su conexión a internet', error.message);
            message = `${error.message}`;
          } else {
            // this.mensajesService.alertaInformativa(error.message);
            message = `${error.message}`;
          }
        } else if (error.Message) {
          message = error.Message;
          // this.mensajesService.alertaInformativa(error.Message);
        }
      }

      try {
        // this.createAccessLogFileAndWrite(`${title} - ${message}`);
      } catch (error) {
        console.log('ERROR al escribir el archivo de LOG');
      } finally {
        await this.mensajesService.alertaInformativaPromise(title, message);
        resolve(true);
      }
      resolve(false);
    });

  }

  public goToLogIn() {
    this.navCtrl.navigateRoot('/log-in', { animated: true });
  }


  // createAccessLogFileAndWrite(text: string) {
  //   this.file.checkFile(this.file.dataDirectory, 'access.log')
  //     .then(doesExist => {
  //       console.log('doesExist : ' + doesExist);
  //       return this.writeToAccessLogFile(text);
  //     }).catch(err => {
  //       return this.file.createFile(this.file.dataDirectory, 'access.log', false)
  //         .then(FileEntry => this.writeToAccessLogFile(text))
  //         .catch(err => console.log('Couldnt create file'));
  //     });
  // }

  // writeToAccessLogFile(text: string) {
  //   this.file.writeExistingFile(this.file.dataDirectory, 'access.log', text);
  // }
}
